import { action } from 'mobx';
import i18next from 'i18next';
import Alert from 'react-s-alert';

import { AppManager, Input } from 'core';
import { analytics } from 'core/analytics';

import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';

import { ThreadApp, CategoryApp } from 'apps/forum/app';
import { ThreadMutation } from 'apps/forum/gql';
import { TagsApp } from 'apps/tag/app';

export class ThreadFormAppManager extends AppManager {
  static registryName = 'ThreadFormAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.threadApp = new ThreadApp(this, {
      category: new CategoryApp(),
      tags: new TagsApp(),
    });
    if (init.categoryId) {
      this.threadApp.createCategoryThreadForm(init.isMember);
    } else {
      this.threadApp.createThreadForm(init.parent.forum.isMember);
    }
    this.input = new Input({
      membersOnly: () => this.threadApp.membersOnly,
      title: () => this.threadApp.title,
      msg: () => this.threadApp.msg,
      categoryId: () => init.categoryId || this.threadApp.categoryId,
      tags: () =>
        this.threadApp.tags.map(({ id, name, deleted }) => ({
          id,
          name,
          deleted,
        })),
    });
  }

  @action
  Submit = () => {
    if (this.threadApp.form.isValid) {
      this.threadApp.form.SetPosting(true);
      clientStore.SetPosting(true);
      this.mutations.push(
        ThreadMutation.New(this.input, {
          onSysErr: this.OnError,
          onUserErr: this.OnError,
          onSuccess: this.OnSuccess,
        }),
      );
    } else {
      this.threadApp.form.alert();
    }
  };

  @action
  OnSuccess = result => {
    this.threadApp.form.SetPosting(false);
    this.threadApp.form.clearDraft();
    clientStore.SetPosting(false);
    modalStore.ClearComponent();
    Alert.success(i18next.t('New Thread posted successfully.'));
    analytics.sendEvent('thread-created');
    const router = clientStore.routerStore;
    router.navigate('initiative.forum.thread', {
      initiative: clientStore.routerStore.params.get('initiative'),
      threadId: result.urlId,
    });
  };

  @action
  OnError = () => {
    this.threadApp.form.SetPosting(false);
    clientStore.SetPosting(false);
    Alert.error(
      i18next.t('Hmm... We failed to post this Thread. Please try again.'),
    );
  };
}
